export const timezones: Record<string, string> = {
  'Abidjan': 'CI',
  'Accra': 'GH',
  'Addis_Ababa': 'ET',
  'Algiers': 'DZ',
  'Asmera': 'ER',
  'Asmara': 'ER',
  'Bamako': 'ML',
  'Bangui': 'CF',
  'Banjul': 'GM',
  'Bissau': 'GW',
  'Blantyre': 'MW',
  'Brazzaville': 'CG',
  'Bujumbura': 'BI',
  'Cairo': 'EG',
  'Casablanca': 'MA',
  'Ceuta': 'ES',
  'Conakry': 'GN',
  'Dakar': 'SN',
  'Dar_es_Salaam': 'TZ',
  'Djibouti': 'DJ',
  'Douala': 'CM',
  'El_Aaiun': 'EH',
  'Freetown': 'SL',
  'Gaborone': 'BW',
  'Harare': 'ZW',
  'Johannesburg': 'ZA',
  'Juba': 'SS',
  'Kampala': 'UG',
  'Khartoum': 'SD',
  'Kigali': 'RW',
  'Kinshasa': 'CD',
  'Lagos': 'NG',
  'Libreville': 'GA',
  'Lome': 'TG',
  'Luanda': 'AO',
  'Lubumbashi': 'CD',
  'Lusaka': 'ZM',
  'Malabo': 'GQ',
  'Maputo': 'MZ',
  'Maseru': 'LS',
  'Mbabane': 'SZ',
  'Mogadishu': 'SO',
  'Monrovia': 'LR',
  'Nairobi': 'KE',
  'Ndjamena': 'TD',
  'Niamey': 'NE',
  'Nouakchott': 'MR',
  'Ouagadougou': 'BF',
  'Porto-Novo': 'BJ',
  'Sao_Tome': 'ST',
  'Tripoli': 'LY',
  'Tunis': 'TN',
  'Windhoek': 'NA',
  'Adak': 'US',
  'Anchorage': 'US',
  'Anguilla': 'AI',
  'Antigua': 'AG',
  'Araguaina': 'BR',
  'Argentina': 'AR',
  'Aruba': 'AW',
  'Asuncion': 'PY',
  'Atikokan': 'CA',
  'Bahia': 'BR',
  'Bahia_Banderas': 'MX',
  'Barbados': 'BB',
  'Belem': 'BR',
  'Belize': 'BZ',
  'Blanc-Sablon': 'CA',
  'Boa_Vista': 'BR',
  'Bogota': 'CO',
  'Boise': 'US',
  'Buenos_Aires': 'AR',
  'Cambridge_Bay': 'CA',
  'Campo_Grande': 'BR',
  'Cancun': 'MX',
  'Caracas': 'VE',
  'Catamarca': 'AR',
  'Cayenne': 'GF',
  'Cayman': 'KY',
  'Chicago': 'US',
  'Chihuahua': 'MX',
  'Ciudad_Juarez': 'MX',
  'Coral_Harbour': 'CA',
  'Cordoba': 'AR',
  'Costa_Rica': 'CR',
  'Coyhaique': 'CL',
  'Creston': 'CA',
  'Cuiaba': 'BR',
  'Curacao': 'CW',
  'Danmarkshavn': 'GL',
  'Dawson': 'CA',
  'Dawson_Creek': 'CA',
  'Denver': 'US',
  'Detroit': 'US',
  'Dominica': 'DM',
  'Edmonton': 'CA',
  'Eirunepe': 'BR',
  'El_Salvador': 'SV',
  'Fort_Nelson': 'CA',
  'Fortaleza': 'BR',
  'Glace_Bay': 'CA',
  'Godthab': 'GL',
  'Goose_Bay': 'CA',
  'Grand_Turk': 'TC',
  'Grenada': 'GD',
  'Guadeloupe': 'GP',
  'Guatemala': 'GT',
  'Guayaquil': 'EC',
  'Guyana': 'GY',
  'Halifax': 'CA',
  'Havana': 'CU',
  'Hermosillo': 'MX',
  'Indiana': 'US',
  'Indianapolis': 'US',
  'Inuvik': 'CA',
  'Iqaluit': 'CA',
  'Jamaica': 'JM',
  'Jujuy': 'AR',
  'Juneau': 'US',
  'Kentucky': 'US',
  'Kralendijk': 'BQ',
  'La_Paz': 'BO',
  'Lima': 'PE',
  'Los_Angeles': 'US',
  'Louisville': 'US',
  'Lower_Princes': 'SX',
  'Maceio': 'BR',
  'Managua': 'NI',
  'Manaus': 'BR',
  'Marigot': 'MF',
  'Martinique': 'MQ',
  'Matamoros': 'MX',
  'Mazatlan': 'MX',
  'Mendoza': 'AR',
  'Menominee': 'US',
  'Merida': 'MX',
  'Metlakatla': 'US',
  'Mexico_City': 'MX',
  'Miquelon': 'PM',
  'Moncton': 'CA',
  'Monterrey': 'MX',
  'Montevideo': 'UY',
  'Montserrat': 'MS',
  'Nassau': 'BS',
  'New_York': 'US',
  'Nome': 'US',
  'Noronha': 'BR',
  'North_Dakota': 'US',
  'Nuuk': 'GL',
  'Ojinaga': 'MX',
  'Panama': 'PA',
  'Paramaribo': 'SR',
  'Phoenix': 'US',
  'Port-au-Prince': 'HT',
  'Port_of_Spain': 'TT',
  'Porto_Velho': 'BR',
  'Puerto_Rico': 'PR',
  'Punta_Arenas': 'CL',
  'Rankin_Inlet': 'CA',
  'Recife': 'BR',
  'Regina': 'CA',
  'Resolute': 'CA',
  'Rio_Branco': 'BR',
  'Santarem': 'BR',
  'Santiago': 'CL',
  'Santo_Domingo': 'DO',
  'Sao_Paulo': 'BR',
  'Scoresbysund': 'GL',
  'Sitka': 'US',
  'St_Barthelemy': 'BL',
  'St_Johns': 'CA',
  'St_Kitts': 'KN',
  'St_Lucia': 'LC',
  'St_Thomas': 'VI',
  'St_Vincent': 'VC',
  'Swift_Current': 'CA',
  'Tegucigalpa': 'HN',
  'Thule': 'GL',
  'Tijuana': 'MX',
  'Toronto': 'CA',
  'Tortola': 'VG',
  'Vancouver': 'CA',
  'Whitehorse': 'CA',
  'Winnipeg': 'CA',
  'Yakutat': 'US',
  'Casey': 'AQ',
  'Davis': 'AQ',
  'DumontDUrville': 'AQ',
  'Macquarie': 'AQ',
  'Mawson': 'AQ',
  'McMurdo': 'AQ',
  'Palmer': 'AQ',
  'Rothera': 'AQ',
  'Syowa': 'AQ',
  'Troll': 'AQ',
  'Vostok': 'AQ',
  'Longyearbyen': 'SJ',
  'Aden': 'YE',
  'Almaty': 'KZ',
  'Amman': 'JO',
  'Anadyr': 'RU',
  'Aqtau': 'KZ',
  'Aqtobe': 'KZ',
  'Ashgabat': 'TM',
  'Atyrau': 'KZ',
  'Baghdad': 'IQ',
  'Bahrain': 'BH',
  'Baku': 'AZ',
  'Bangkok': 'TH',
  'Barnaul': 'RU',
  'Beirut': 'LB',
  'Bishkek': 'KG',
  'Brunei': 'BN',
  'Calcutta': 'IN',
  'Chita': 'RU',
  'Colombo': 'LK',
  'Damascus': 'SY',
  'Dhaka': 'BD',
  'Dili': 'TL',
  'Dubai': 'AE',
  'Dushanbe': 'TJ',
  'Famagusta': 'CY',
  'Gaza': 'PS',
  'Hebron': 'PS',
  'Ho_Chi_Minh': 'VN',
  'Hong_Kong': 'HK',
  'Hovd': 'MN',
  'Irkutsk': 'RU',
  'Jakarta': 'ID',
  'Jayapura': 'ID',
  'Jerusalem': 'IL',
  'Kabul': 'AF',
  'Kamchatka': 'RU',
  'Karachi': 'PK',
  'Katmandu': 'NP',
  'Kathmandu': 'NP',
  'Khandyga': 'RU',
  'Kolkata': 'IN',
  'Krasnoyarsk': 'RU',
  'Kuala_Lumpur': 'MY',
  'Kuching': 'MY',
  'Kuwait': 'KW',
  'Macau': 'MO',
  'Magadan': 'RU',
  'Makassar': 'ID',
  'Manila': 'PH',
  'Muscat': 'OM',
  'Nicosia': 'CY',
  'Novokuznetsk': 'RU',
  'Novosibirsk': 'RU',
  'Omsk': 'RU',
  'Oral': 'KZ',
  'Phnom_Penh': 'KH',
  'Pontianak': 'ID',
  'Pyongyang': 'KP',
  'Qatar': 'QA',
  'Qostanay': 'KZ',
  'Qyzylorda': 'KZ',
  'Rangoon': 'MM',
  'Riyadh': 'SA',
  'Saigon': 'VN',
  'Sakhalin': 'RU',
  'Samarkand': 'UZ',
  'Seoul': 'KR',
  'Shanghai': 'CN',
  'Singapore': 'SG',
  'Srednekolymsk': 'RU',
  'Taipei': 'TW',
  'Tashkent': 'UZ',
  'Tbilisi': 'GE',
  'Tehran': 'IR',
  'Thimphu': 'BT',
  'Tokyo': 'JP',
  'Tomsk': 'RU',
  'Ulaanbaatar': 'MN',
  'Urumqi': 'CN',
  'Ust-Nera': 'RU',
  'Vientiane': 'LA',
  'Vladivostok': 'RU',
  'Yakutsk': 'RU',
  'Yangon': 'MM',
  'Yekaterinburg': 'RU',
  'Yerevan': 'AM',
  'Azores': 'PT',
  'Bermuda': 'BM',
  'Canary': 'ES',
  'Cape_Verde': 'CV',
  'Faeroe': 'FO',
  'Faroe': 'FO',
  'Madeira': 'PT',
  'Reykjavik': 'IS',
  'South_Georgia': 'GS',
  'St_Helena': 'SH',
  'Stanley': 'FK',
  'Adelaide': 'AU',
  'Brisbane': 'AU',
  'Broken_Hill': 'AU',
  'Darwin': 'AU',
  'Eucla': 'AU',
  'Hobart': 'AU',
  'Lindeman': 'AU',
  'Lord_Howe': 'AU',
  'Melbourne': 'AU',
  'Perth': 'AU',
  'Sydney': 'AU',
  'Amsterdam': 'NL',
  'Andorra': 'AD',
  'Astrakhan': 'RU',
  'Athens': 'GR',
  'Belgrade': 'RS',
  'Berlin': 'DE',
  'Bratislava': 'SK',
  'Brussels': 'BE',
  'Bucharest': 'RO',
  'Budapest': 'HU',
  'Busingen': 'DE',
  'Chisinau': 'MD',
  'Copenhagen': 'DK',
  'Dublin': 'IE',
  'Gibraltar': 'GI',
  'Guernsey': 'GG',
  'Helsinki': 'FI',
  'Isle_of_Man': 'IM',
  'Istanbul': 'TR',
  'Jersey': 'JE',
  'Kaliningrad': 'RU',
  'Kiev': 'UA',
  'Kirov': 'RU',
  'Kyiv': 'UA',
  'Lisbon': 'PT',
  'Ljubljana': 'SI',
  'London': 'GB',
  'Luxembourg': 'LU',
  'Madrid': 'ES',
  'Malta': 'MT',
  'Mariehamn': 'FI',
  'Minsk': 'BY',
  'Monaco': 'MC',
  'Moscow': 'RU',
  'Oslo': 'NO',
  'Paris': 'FR',
  'Podgorica': 'ME',
  'Prague': 'CZ',
  'Riga': 'LV',
  'Rome': 'IT',
  'Samara': 'RU',
  'San_Marino': 'SM',
  'Sarajevo': 'BA',
  'Saratov': 'RU',
  'Simferopol': 'UA',
  'Skopje': 'MK',
  'Sofia': 'BG',
  'Stockholm': 'SE',
  'Tallinn': 'EE',
  'Tirane': 'AL',
  'Ulyanovsk': 'RU',
  'Vaduz': 'LI',
  'Vatican': 'VA',
  'Vienna': 'AT',
  'Vilnius': 'LT',
  'Volgograd': 'RU',
  'Warsaw': 'PL',
  'Zagreb': 'HR',
  'Zurich': 'CH',
  'Antananarivo': 'MG',
  'Chagos': 'IO',
  'Christmas': 'CX',
  'Cocos': 'CC',
  'Comoro': 'KM',
  'Kerguelen': 'TF',
  'Mahe': 'SC',
  'Maldives': 'MV',
  'Mauritius': 'MU',
  'Mayotte': 'YT',
  'Reunion': 'RE',
  'Apia': 'WS',
  'Auckland': 'NZ',
  'Bougainville': 'PG',
  'Chatham': 'NZ',
  'Chuuk': 'FM',
  'Easter': 'CL',
  'Efate': 'VU',
  'Enderbury': 'KI',
  'Fakaofo': 'TK',
  'Fiji': 'FJ',
  'Funafuti': 'TV',
  'Galapagos': 'EC',
  'Gambier': 'PF',
  'Guadalcanal': 'SB',
  'Guam': 'GU',
  'Honolulu': 'US',
  'Kanton': 'KI',
  'Kiritimati': 'KI',
  'Kosrae': 'FM',
  'Kwajalein': 'MH',
  'Majuro': 'MH',
  'Marquesas': 'PF',
  'Midway': 'US',
  'Nauru': 'NR',
  'Niue': 'NU',
  'Norfolk': 'NF',
  'Noumea': 'NC',
  'Pago_Pago': 'AS',
  'Palau': 'PW',
  'Pitcairn': 'PN',
  'Ponape': 'FM',
  'Pohnpei': 'FM',
  'Port_Moresby': 'PG',
  'Rarotonga': 'CK',
  'Saipan': 'MP',
  'Tahiti': 'PF',
  'Tarawa': 'KI',
  'Tongatapu': 'TO',
  'Truk': 'FM',
  'Wake': 'UM',
  'Wallis': 'WF',
};

export const alternates: Record<string, string[]> = {
  Cairo: ['LY'],
  Johannesburg: ['LS', 'SZ'],
  Nairobi: ['UG', 'TZ', 'ET', 'SS', 'DJ', 'ER', 'SO'],
  New_York: ['CA', 'BS', 'JM', 'HT', 'TC'],
  Chicago: ['CA', 'MX', 'BZ', 'GT', 'SV', 'HN', 'NI'],
  Denver: ['CA', 'MX'],
  Los_Angeles: ['CA', 'MX'],
  Phoenix: ['MX'],
  Argentina: ['UY'],
  Bangkok: ['VN', 'KH', 'LA'],
  Dubai: ['OM'],
  Singapore: ['MY', 'PH', 'BN'],
  Taipei: ['CN'],
  Hong_Kong: ['CN'],
  Paris: ['BE', 'LU', 'MC', 'AD'],
  Berlin: ['AT', 'CH', 'LI', 'LU'],
  Moscow: ['BY'],
  London: ['IE', 'GG', 'JE', 'IM'],
  Istanbul: ['CY'],
  Brussels: ['LU', 'FR', 'NL'],
};
